import { updateUnleashContext } from './unleash'

export interface UserContextProfile {
  email?: string | null
  username?: string | null
}

export function syncUnleashUserContext(profile: UserContextProfile): void {
  updateUnleashContext({
    email: profile.email?.trim().toLowerCase() ?? undefined,
    username: profile.username ?? undefined
  })
}

export function clearUnleashUserContext(): void {
  updateUnleashContext({ email: undefined, username: undefined })
}
